export const DEDUPE_WINDOW_MS = 500

const recentTracks = new Map<string, number>()

const isPrimitiveProperty = (
  value: unknown
): value is string | number | boolean =>
  typeof value === 'string' ||
  typeof value === 'number' ||
  typeof value === 'boolean'

export const buildTrackFingerprint = (
  eventName: string,
  properties: Record<string, unknown> = {}
): string => {
  const stableEntries = Object.entries(properties)
    .filter(([, value]) => isPrimitiveProperty(value))
    .sort(([leftKey], [rightKey]) => leftKey.localeCompare(rightKey))

  return `${eventName}::${JSON.stringify(stableEntries)}`
}

export type DuplicateTrackDecision =
  | { block: false; fingerprint: string }
  | { block: true; fingerprint: string; deltaMs: number }

export const evaluateDuplicateTrack = (
  eventName: string,
  properties: Record<string, unknown>,
  now: number
): DuplicateTrackDecision => {
  const fingerprint = buildTrackFingerprint(eventName, properties)
  const lastSentAt = recentTracks.get(fingerprint)

  if (lastSentAt !== undefined && now - lastSentAt < DEDUPE_WINDOW_MS) {
    return {
      block: true,
      fingerprint,
      deltaMs: now - lastSentAt,
    }
  }

  return { block: false, fingerprint }
}

export const recordAllowedTrack = (fingerprint: string, now: number): void => {
  recentTracks.set(fingerprint, now)

  for (const [key, timestamp] of recentTracks) {
    if (now - timestamp > DEDUPE_WINDOW_MS * 2) {
      recentTracks.delete(key)
    }
  }
}

export const resetDuplicateTrackRegistryForTests = (): void => {
  recentTracks.clear()
}
